import React from 'react'
import { PageContent, Heading, Text, Message, Button, Style } from '@brainstud/react-tbl/themes/pgw/v1/components/library'
import { translate } from '@brainstud/react-tbl/themes/pgw/v1/translations'
import QuestionForm from '../../endtest/components/QuestionForm'
import { compareAnswers, scrollTop } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import { EndtestData } from '../../../../config'

// TODO remove grid system dependecy
const Container = props => props.children
const Row = props => props.children
const Col = props => props.children

class LessonQuiz extends React.Component {
  state = {
    questions: [...this.props.lesson.questions],
    quiz: this.props.data ? {...this.props.data} : {...EndtestData},
  }

  get isComplete() {
    return this.state.questions.length === this.state.quiz.answers.length
  }

  pickSingle = (e, qId) => {
    const value = e.target.value
    const answer = { qId, value: [value] }

    this.setState(prevState => ({
      quiz: {
        ...prevState.quiz,
        answers: prevState.quiz.answers.find(item => item.qId === qId)
          ? prevState.quiz.answers.map(item => item.qId === qId ? {...answer}: item)
          : prevState.quiz.answers.concat(answer)
      }
    }))
  }

  pickMultiple = (e, qId) => {
    const value = e.target.value

    this.setState(prevState => {
      const answer = prevState.quiz.answers.find(item => item.qId === qId)
      const answerValue = (answer && answer.value) || []

      const newAnswer = {
        qId,
        value: answerValue.indexOf(value) === -1
          ? answerValue.concat(value)
          : answerValue.filter(val => val !== value)
      }

      return {
        quiz: {
          ...prevState.quiz,
          answers: answer
            ? prevState.quiz.answers.map(item => item.qId === qId ? {...newAnswer}: item)
            : prevState.quiz.answers.concat(newAnswer)
        }
      }
    })
  }

  pickDragDrop = e => {
    const item = e.dragData
    const target = e.dropData

    this.setState(prevState => {
      const formAnswer = prevState.quiz.answers.find(item => item.qId === target.qId)
      const formAnswerValue = (formAnswer && formAnswer.value) || []
      const pickedAnswer = { aId: item.id, location: target.id, label: item.id }

      const pickedAnswers = formAnswerValue.find(a => a.aId === pickedAnswer.aId)
          ? formAnswerValue.map(val => val.aId === pickedAnswer.aId ? {...pickedAnswer} : val)
          : formAnswerValue.concat(pickedAnswer)

      const newFormAnswer = { qId: target.qId, value: pickedAnswers }

      return {
        quiz: {
          ...prevState.quiz,
          answers: formAnswer
            ? prevState.quiz.answers.map(i => i.qId === newFormAnswer.qId ? {...newFormAnswer} : i)
            : prevState.quiz.answers.concat(newFormAnswer)
        }
      }
    })
  }

  handleSubmit = e => {
    this.state.questions.map(question => {
      const answerPick = this.state.quiz.answers.find(item => item.qId === question.id)

      if(answerPick) {
        const userAnswers = []
        const correctAnswers = []
        const status = {}

        switch(question.type) {
          case 'single':
          case 'multiple':
            userAnswers.push(...answerPick.value)
            question.answers.map(item => {
              if(item.isCorrect) {
                correctAnswers.push(item.id.toString())
              }

              return null
            })
            break

          case 'dragdrop':
            answerPick.value.map(item => userAnswers.push({ aId: item.aId, location: item.location }))
            question.answers.map(item => correctAnswers.push({ aId: item.id, location: item.isCorrect }))
            break

          default:
            return null
        }

        status.total = correctAnswers.length
        status.picked = compareAnswers(question.type, correctAnswers, userAnswers)
        const currentScore = () => {
          switch(question.type) {
            case 'single':
            case 'multiple':
              return status.picked.correct - status.picked.wrong === status.total ? question.points : 0

            case 'dragdrop':
              return status.picked.correct * (question.points / status.total)

            default:
              return 0
          }
        }
        status.score = currentScore()
        status.passed = status.score >= question.points

        this.setState(prevState => ({
          quiz: {
            ...prevState.quiz,
            score: prevState.quiz.score + status.score,
            answers: prevState.quiz.answers.map(item => item.qId === answerPick.qId
              ? {...item, status}
              : item)
          }
        }))
      }

      return null
    })

    this.setState(prevState => ({
      quiz: {
        ...prevState.quiz,
        completed: this.isComplete,
        passed: this.props.lesson.scoreToPass > 0 ? prevState.quiz.score >= this.props.lesson.scoreToPass : true,
      }
    }), () => this.props.save(this.state.quiz))

    scrollTop()
  }

  render() {
    const getValue = question => {
      const answer = this.state.quiz.answers.find(item => item.qId === question.id)
      return answer && answer.value
    }

    const getType = question => {
      const types = {
        single: this.pickSingle,
        multiple: this.pickMultiple,
        dragdrop: this.pickDragDrop
      }

      return types[question.type]
    }

    const getStatus = question => {
      const answer = this.state.quiz.answers.find(item => item.qId === question.id)
      return answer && answer.status
    }

    const isCorrect = q => this.isComplete && getStatus(q) && getStatus(q).passed
    const isWrong = q => this.isComplete && getStatus(q) && !getStatus(q).passed

    return (
      <PageContent>
        <Container>
          {this.state.questions.map((question, idx) => (
            <Row nogutter className="Quiz-question" key={idx}>
              <Col lg={6} className="Quiz-question-main">
                <Text small>{translate('endtest.questionNo', { number: question.id })}</Text>
                <Text>{question.info}</Text>

                <Heading h3>{question.title}</Heading>
              </Col>
              <Col lg={6} className="Quiz-question-info">
                {isWrong(question) &&
                  <Message error title={question.message.wrong.title}>
                    <Text>{question.message.wrong.info}</Text>
                  </Message>
                }

                {isCorrect(question) &&
                  <Message success title={question.message.correct.title}></Message>
                }

                <QuestionForm
                  {...question}
                  disabled={this.state.quiz.completed}
                  value={getValue(question)}
                  onPick={getType(question)} />
              </Col>
            </Row>
          ))}
        </Container>

        {!this.state.quiz.completed &&
          <Style.Center>
            <Button primary square
              disabled={!this.isComplete}
              onClick={this.handleSubmit}
              label={translate('app.submitQuiz')} />
          </Style.Center>
        }
      </PageContent>
    )
  }
}

export default LessonQuiz
